<div fxLayout="column" class="p-4" [ngStyle]="{'max-height.px': innerHeight}">

    <div *ngIf="currUser.providerId !== 'password'" fxLayout="column" fxLayoutAlign="center center" class="text-center layout-padd">

        <div class="">
            <span class="mat-title boldest">
              {{'confirmBlockComponent.sure' | translate}}
         {{(block ? 'confirmBlockComponent.block' : 'confirmBlockComponent.unblock')| translate}}  {{'confirmBlockComponent.card' | translate}} ?
      </span>
        </div>

        <span class="mat-subheading-1" *ngIf="block">
          {{'confirmBlockComponent.blocked' | translate}}

    </span>

        <span class="mat-subheading-1" *ngIf="!block">
          {{'confirmBlockComponent.unblocked' | translate}}

    </span>

    </div>

    <div fxLayout="column" fxLayoutGap="10px" *ngIf="currUser.providerId === 'password'">

        <div class="layout-padd">
            <span class="mat-subheading-1">{{'confirmBlockComponent.passrequired' | translate}}
        {{(block ? 'confirmBlockComponent.block' : 'confirmBlockComponent.unblock')| translate}} {{'confirmBlockComponent.card' | translate}}</span>
        </div>

        <div class="layout-padd">

            <mat-form-field fxFlex>
                <mat-label>{{'confirmBlockComponent.pass' | translate}}</mat-label>
                <input matInput type="password" [(ngModel)]="password" placeholder="{{'confirmBlockComponent.pass' | translate}}">
            </mat-form-field>

        </div>

    </div>

    <!-- Error message -->
    <mat-card fxLayout="row" fxLayoutAlign="center center" class="text-center warn" *ngIf="errorPassword">
        <span class="mat-subheading-2">{{'confirmBlockComponent.passinvalid' | translate}}</span>
    </mat-card>

    <!-- If password-email -->
    <div fxLayout="row" fxLayoutGap="10px" class="mt-4">
        <button fxFlex [ngClass]="cssService.defaultNegativeDialogButton" (click)="closeDial(false)" angulartics2On="click" angularticsAction="cancelRecharge" angularticsCategory="rechargeCard">
          {{'button.no' | translate}}
        </button>

        <button fxFlex [ngClass]="cssService.defaultPositiveDialogButton" (click)="closeDial(true)" [disabled]="currUser.providerId === 'password' && !password" angulartics2On="click" angularticsAction="confirmRecharge" angularticsCategory="rechargeCard">
          {{'button.yes' | translate}}
    </button>
    </div>


    <app-popup-loader [flagLoading]="loader" [statusMessage]="'confirmBlockComponent.verifpass' | translate" [size]="30"></app-popup-loader>

</div>
